import { differenceInMinutes, OwaDate } from 'owa-datetime';

/**
 * Utility to return grid Height
 * @param gridStartTime Start time of the grid
 * @param gridEndTime End time of the grid
 * @param pixelPerMin Number of pixel per minute
 */
export default function getTimeGridHeight(
    gridStartTime: OwaDate,
    gridEndTime: OwaDate,
    pixelPerMin: number
): number {
    const minutesDuration = differenceInMinutes(gridEndTime, gridStartTime);
    if (minutesDuration >= 0) {
        return minutesDuration * pixelPerMin;
    } else {
        throw new Error("TimeGrid's Start cannot be after End");
    }
}
